import { rgba } from 'polished';

const colors = {
  gray10: '#f9f9f9',
  gray20: '#dbdbdb',
  gray30: '#c6c6c6',
  gray40: '#a9a9a9',
  gray50: '#909090',
  gray100: '#7b7b7b',
  gray200: '#565656',
  gray300: '#3f3f3f',
  gray400: '#363636',
  gray500: '#2d2d2d',
  gray600: '#272727',
  gray700: '#1e1e1e',
  gray800: '#191919',
  gray900: '#101010',
  white: '#ffffff',
  teal50: '#e0edee',
  teal100: '#b3d8da',
  teal200: '#83c3c7',
  teal300: '#4faeb2',
  teal400: '#25a0a2',
  teal500: '#009090',
  teal600: '#008281',
  teal700: '#057472',
  teal800: '#006462',
  teal900: '#004843',
  black: '#000000',
  blue50: '#d4ecff',
  blue100: '#a7d8ff',
  blue200: '#7dc6ff',
  blue300: '#50b1ff',
  blue400: '#309fff',
  blue500: '#0090ff',
  blue600: '#0181f0',
  blue700: '#0c70de',
  blue800: '#005fcc',
  blue900: '#0041ae',
  navy50: '#cabee1',
  navy100: '#ae9dd7',
  navy200: '#8f77c7',
  navy300: '#6f51bc',
  navy400: '#5533b0',
  navy500: '#3a13a7',
  navy600: '#2e10a3',
  navy700: '#1e0498',
  navy800: '#000090',
  navy900: '#000465',
  red50: '#eaeaea',
  red100: '#f2c9c6',
  red200: '#f3a6a2',
  red300: '#f98480',
  red400: '#fb6265',
  red500: '#ff424f',
  red600: '#f33c49',
  red700: '#e63745',
  red800: '#e02f3e',
  red900: '#be2434',
  yellow50: '#f9f9f9',
  yellow100: '#f4ead2',
  yellow200: '#efd79f',
  yellow300: '#ebc36b',
  yellow400: '#eab448',
  yellow500: '#eba832',
  yellow600: '#e79d2d',
  yellow700: '#e28f29',
  yellow800: '#dc8024',
  yellow900: '#d4691d',
  green50: '#d9f1cb',
  green100: '#c2e6aa',
  green200: '#a7d987',
  green300: '#8dce61',
  green400: '#79c542',
  green500: '#63bc1f',
  green600: '#52ab15',
  green700: '#419808',
  green800: '#2c8500',
  green900: '#006300',
  pink: 'pink',
  purple: 'purple',
  orange: 'orange',
  red: 'red',
  gray: 'gray',
};

const breakpointsAlias = {
  xs: '0px',
  sm: '576px',
  md: '768px',
  lg: '992px',
  xl: '1200px',
  xxl: '1400px',
};

export const defaultTheme = {
  colors: {
    ...colors,

    newTripStepBG: colors.green300,
    newTripStepActiveBG: colors.blue100,
    newTripStepBorder: colors.gray600,
    newTripStepLine: colors.gray20,
    newTripStepLineActive: colors.gray600,
    newTripStepLabel: colors.gray50,
    newTripStepLabelActive: colors.gray600,
    newTripStepNumberActive: colors.white,

    simpleText: '#000000',

    primaryText: '#2c304d',

    placeholderText: '#98a8b4',

    errorTextMessage: '#94a4b0',

    sideBarIconActive: '#97bf3d',
    sideBarIconInactive: '#98a8b4',
    sideBarText: '#aea9c3',

    billsActionIcon: '#98a8b4',
    billsActionIconHover: '#FFFFFF',
    billsActionIconBackgroundHover: '#97bf3d',

    dataCardDefaultTitleColor: '#00000080',
    dataCardPrimaryTitleColor: '#97bf3d',

    styledForm: '#342868',

    profileItemText: '#5d5386',

    sidebarBackground: '#2c304d',

    tableTextColor: '#5d5386',
    tableHead: '#342868',
    tableTh: '#e0dfe9',

    dataBoxText: '#2c304d',

    inputText: '#2c304d',
    inputBorder: '#eee',
    inputBorderFocus: '#5d5386',

    // Buttons
    shadowButtonText: '#5d5386',

    primaryButtonBackground: '#97bf3d',
    primaryButtonHover: '#88ab3f',
    primaryButtonText: '#FFFFFF',

    successButtonBackground: '#60c400',
    successButtonText: '#FFFFFF',
    successButtonHover: '#00662B',

    errorButtonBackground: '#fe195e',
    errorButtonText: '#FFFFFF',
    errorButtonHover: '#c9302c',

    infoButtonBackground: '#5bc0de',
    infoButtonText: '#FFFFFF',
    infoButtonHover: '#31b0d5',

    defaultButtonBackground: '#e4e8f0 ',
    defaultButtonText: '#2c304d',
    defaultButtonHover: '#2C304d',
    defaultButtonTextHover: '#FFFFFF',

    //
    inboxSpinner: '#2c304d',

    // PAGINATION
    pagination: '#aea9c3',
    paginationActive: '#5d5386',

    dropdownDisabled: colors.gray30,

    dropdownSelectBackground: '#f8f9fa',
    dropdownSelectText: '#999',
    dropdownSelectTextSelected: '#2c304d',
    dropdownSelectBorderFocus: '#5d5386',

    accordionText: '#5d5386',
    accordionTextHover: '#97bf3d',

    //
    chartSuccess: 'green',
    chartError: 'red',
    chartInfo1: 'gray',

    errorIconColor: '#ce4926',
    successIconColor: '#8aab3c',
    disabledIconColor: '#e1e2e4',

    toggleSwitchTrueBackground: colors.green400,
    toggleSwitchFalseBackground: colors.red400,

    toggleSwitchDisabledTrueBackground: colors.green100,
    toggleSwitchDisabledFalseBackground: colors.red100,

    toggleButtonTrueBackground: colors.green400,
    toggleButtonFalseBackground: colors.red400,

    toggleButtonDisabledTrueBackground: colors.green100,
    toggleButtonDisabledFalseBackground: colors.red100,

    tableRowPending: colors.gray20,
    tableRowPendingHover: colors.gray30,

    tableRowNotAvailable: colors.yellow200,
    tableRowNotAvailableHover: colors.yellow300,

    reportKpiLabel: colors.gray30,
    reportKpiValue: colors.gray800,
    reportKpiBackground: colors.white,

    iconButtonBackground: rgba(colors.black, 0.06),
    iconButtonBackgroundHover: rgba(colors.black, 0.1),

    formInputAutocompleteItemBGSelected: rgba(colors.gray20, 0.8),
    formInputAutocompleteItemBoderFocus: colors.gray40,
    formInputAutocompleteItemBGHover: colors.gray20,

    disabledBackground300: rgba(colors.white, 0.3),
    disabledBackground500: rgba(colors.white, 0.5),
  },

  sizes: {
    sideBarWidth: '17.5rem',
    sideBarCollapsedWidth: '5.5rem',
  },

  shadows: {
    xs: '0px 0px 1px 1px rgba(52, 40, 104, 0.08)',
    sm: '0px 0px 2px 1px rgba(52, 40, 104, 0.08)',
    md: '0px 0px 4px 1px rgba(52, 40, 104, 0.08)',
    lg: '0px 0px 15px 1px rgba(52, 40, 104, 0.08)',
    xl: '0px 0px 15px 3px rgba(52, 40, 104, 0.08)',
    xxl: '0px 0px 15px 5px rgba(52, 40, 104, 0.08)',
  },

  fontSizes: {
    xs: '0.56rem',
    sm: '0.72rem',
    md: '0.8rem',
    lg: '1rem',
    xl: '1.6rem',
    xxl: '2rem',
    xxxl: '2.56rem',
  },

  fontWeights: {
    reg: '300',
    med: '500',
    sem: '600',
    bld: '700',
  },

  default: {
    fontFamily: "'Montserrat', sans-serif",
    backgroundColor: '#f2f3f8',
  },

  breakpoints: [
    breakpointsAlias.xs,
    breakpointsAlias.sm,
    breakpointsAlias.md,
    breakpointsAlias.lg,
    breakpointsAlias.xl,
    breakpointsAlias.xxl,
  ],

  mediaQueries: {
    up: {
      sm: `@media screen and (min-width: ${breakpointsAlias.sm})`,
      md: `@media screen and (min-width: ${breakpointsAlias.md})`,
      lg: `@media screen and (min-width: ${breakpointsAlias.lg})`,
      xl: `@media screen and (min-width: ${breakpointsAlias.xl})`,
      xxl: `@media screen and (min-width: ${breakpointsAlias.xxl})`,
    },
    down: {
      sm: `@media screen and (max-width: ${breakpointsAlias.sm})`,
      md: `@media screen and (max-width: ${breakpointsAlias.md})`,
      lg: `@media screen and (max-width: ${breakpointsAlias.lg})`,
      xl: `@media screen and (max-width: ${breakpointsAlias.xl})`,
      xxl: `@media screen and (max-width: ${breakpointsAlias.xxl})`,
    },
  },
};
